// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 30) return "static/chunks/30.c924c0cb7bc44ecb.js";
	if (chunkId === 966) return "static/chunks/64abf602.52d24cdd0be1b0fd.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 793 ? "fec60073" : chunkId) + "-" + {"252":"aef2d3bdd1c3bb74","438":"c0fc1ef5958faf45","793":"bb5a9b9e12753987"}[chunkId] + ".js";
};